export const RECOMMENED_FAREKEY = 'recommendedFareKey';
export const MANUALLY_REMOVED_PRODUCTS = 'manuallyRemovedProductIds';
export const MANUALLY_ADDED_PRODUCTS = 'manuallyAddedProductIds';
